import { render, staticRenderFns } from "./financeiro-cadastro-responsavel-empresa-medica.vue?vue&type=template&id=6b88c184&scoped=true"
import script from "./financeiro-cadastro-responsavel-empresa-medica.vue?vue&type=script&lang=ts"
export * from "./financeiro-cadastro-responsavel-empresa-medica.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-cadastro-responsavel-empresa-medica.vue?vue&type=style&index=0&id=6b88c184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b88c184",
  null
  
)

export default component.exports